import axios from 'axios';
import { config } from '../config';
import store from "../store";
import { AuthModel } from "./auth.service"

//axios.defaults.baseURL = config.$api_url;

const instance = axios.create({
    baseURL: config.$api_url,
    timeout: config.timeoutDuration
});

const access = {
    grant_type: config.api_grant_type,
    username: config.api_username,
    password: config.api_password,
    client_id: config.api_client_id,
    client_secret: config.api_client_secret,
    scope: '*'
};

const token = localStorage.getItem('token');

if (token) {
    instance.defaults.headers.Authorization = 'Bearer ' + token
}
else {

    //console.log('Display Vue Store: ')
    //console.log('Display Vue Store: ' + store)
    //store.dispatch('login', access).then(resp => { /* Do stuff */}).catch(err => console.log(err));
}

instance.interceptors.request.use(async function (request) {
    
    const token = localStorage.getItem('token');
    
    if (token) {
        if (!request.headers.Authorization) {
            request.headers.Authorization = 'Bearer ' + token;
        }

        //console.log(store)
    }
    else {
        console.log('Interceptor token not found');
        //store.dispatch('login', access).then(resp => { /* Do stuff */}).catch(err => console.log(err));
        await AuthModel.login(access).then(resp => { 
            //console.log(resp),
            request.headers.Authorization = 'Bearer ' + resp.data.access_token,
            localStorage.setItem('token', resp.data.access_token)
        })
        .catch(err => console.log(err));
    }

    return request;

}, function (error) {
    // Do something with request error
    console.log('intercept erro: ' + error);
    return Promise.reject(error)
})

export default instance


// WEBPACK FOOTER //
// ./src/api-services/axios.instance.js